
// Imports
import { SetupContext } from "vue";

// Types
interface Props {
  variantType?: TBtnType;
  variantColor?: TvariantColor;
  isDisabled?: boolean;
  value?: string;
  size?: TbtnSize;
  textId?: string;
}

type TBtnType = "primary-outlined" | "primary-contained" | "transparent";

type TvariantColor = "primary" | "secondary";
type TbtnSize = "sm" | "md" | "lg";

// @component
export default {
  name: "BaseButton",
  props: {
    type: {
      type: String,
      default: "button",
    },
    variantType: {
      type: String as () => TBtnType,
      default: "primary-contained",
    },
    variantColor: {
      type: String as () => TvariantColor,
      default: "primary",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String as () => TbtnSize,
      default: "md",
    },
    textId: {
      type: String,
    },
  },

  setup(props: Props, { emit }: SetupContext) {
    return { emit };
  },
  emits: ["on-click"],
};
